import { Box, Chip, Stack, Tab, TabList } from "@compass/core";
import { ApplicationViewResource } from "generated/openApi";
import "moment-timezone";
import { ApplicationTab } from "./ApplicationPage";

type ApplicationPageTabsProps = {
  viewResource: ApplicationViewResource;
  setCurrentTab: (value: ApplicationTab) => void;
};

export const ApplicationPageTabs = ({ viewResource, setCurrentTab }: ApplicationPageTabsProps) => {
  const tabs: ApplicationTab[] = ["General", "Sections", "Questions"];

  const tabTotals: [ApplicationTab, number | undefined][] = [
    ["Sections", viewResource?.applicationSectionCount],
    ["Questions", viewResource?.applicationQuestionCount],
  ];

  return (
    <TabList
      onChange={(e, value) => setCurrentTab(value)}
      variant="scrollable"
      scrollButtons
      allowScrollButtonsMobile
    >
      {tabs.map((tab) => {
        const total: number | undefined = tabTotals.find((x) => x[0] === tab)?.[1];

        return (
          <Tab
            key={tab}
            label={
              <Stack direction="row" spacing="sm" alignItems="center">
                <Box>{tab}</Box>
                {total !== undefined && total !== null && <Chip label={total} size="small" />}
              </Stack>
            }
            value={tab}
          />
        );
      })}
    </TabList>
  );
};
